    <div class="text-center my-3">
      <p class="mb-3 text-600 mr-4">{{ 'REPORTS.REPORT_TEMPLATE.EMPTY_REPORT' | translate}}</p>
    <img src="/assets/img/empty-reports-img.svg" alt="No Reports" />
  </div>
